export const Constants = {
  loading: 'carregando...',
  download: 'download',
  noPdf: 'não foi possível recuperar o relatório',
};
